module.exports = __webpack_public_path__ + "static/img/street_view.afe9a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/street_view.png
// module id = XHuZ
// module chunks = 1